// extracted by mini-css-extract-plugin
module.exports = {"container":"Toasts_container__5Nwcl"};